import React from 'react';
import Header from './Component/Header';
import Footer from './Component/Footer';
import Request from './Component/requestEstimate';
import PageHero from './Component/PageHero';
import s2 from './Component/s2.png';

function Contact() {
  return (
    <div className="min-h-screen bg-[#f7f8fa] text-slate-900 antialiased">
      <Header />
      <PageHero
        eyebrow="Get in touch"
        title="Contact us"
        subtitle="Reach the flooring professionals at PacifiContract"
      />

      <section className="pb-8 md:pb-12">
        <div className="mx-auto grid max-w-6xl gap-6 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-[1.75rem] bg-white ring-1 ring-slate-200/80 [&_section]:bg-transparent [&_section]:py-6 [&_section]:sm:py-8">
              <Request />
            </div>
          </div>

          <aside className="lg:col-span-4">
            <div className="rounded-[1.75rem] bg-white p-6 shadow-sm ring-1 ring-slate-200/80 sm:p-8">
              <h2 className="text-lg font-semibold sm:text-xl">Store info</h2>

              <div className="mt-5 space-y-5 text-sm sm:text-base">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                    Address
                  </p>
                  <p className="mt-1 text-slate-800">9 Jordan St., San Rafael, CA 94901</p>
                  <a
                    href="https://www.google.com/maps/place/PacifiContract+Flooring+%7C+LVP+%26+Carpet+Installation/@37.9681707,-122.5282297,862m/data=!3m1!1e3!4m15!1m8!3m7!1s0x808599f81c5f6e01:0xc00c65e1f339f07f!2sPacifiContract+Flooring+%7C+LVP+%26+Carpet+Installation!8m2!3d37.9681665!4d-122.5256548!10e1!16s%2Fg%2F1tdc5f_7!3m5!1s0x808599f81c5f6e01:0xc00c65e1f339f07f!8m2!3d37.9681665!4d-122.5256548!16s%2Fg%2F1tdc5f_7?hl=en&entry=ttu&g_ep=EgoyMDI2MDcyMi4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noreferrer"
                    className="mt-3 inline-flex w-full items-center justify-center rounded-full bg-[#0075ca] px-4 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-[#0063ad]"
                  >
                    Get directions
                  </a>
                </div>

                <div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                    Phone
                  </p>
                  <a
                    href="tel:+14152180103"
                    className="mt-1 block font-medium text-slate-800 no-underline"
                  >
                    (415) 218-0103
                  </a>
                  <a
                    href="tel:+14152180103"
                    className="mt-3 inline-flex w-full items-center justify-center rounded-full border border-slate-300 px-4 py-2.5 text-sm font-semibold text-slate-800 no-underline transition hover:border-slate-400"
                  >
                    Call us
                  </a>
                </div>

                <div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
                    Hours
                  </p>
                  <p className="mt-1 text-slate-800">
                    Mon–Fri 9am – 5pm
                    <br />
                    Sat–Sun Closed
                  </p>
                </div>

                <a
                  href="/free-estimate"
                  className="inline-flex w-full items-center justify-center rounded-full bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white no-underline transition hover:bg-slate-800"
                >
                  Request an estimate
                </a>
              </div>
            </div>
          </aside>
        </div>
      </section>

      <div className="mx-auto max-w-6xl px-4 pb-8 sm:px-6 lg:px-8">
        <a href="/financing" className="block overflow-hidden rounded-[1.75rem]">
          <img src={s2} alt="Financing options" className="w-full object-cover" />
        </a>
      </div>

      <div className="mx-auto max-w-6xl px-4 pb-12 sm:px-6 lg:px-8">
        <div className="overflow-hidden rounded-[1.75rem] ring-1 ring-slate-200/80">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3145.383837896004!2d-122.5282297!3d37.9681707!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808599f81c5f6e01%3A0xc00c65e1f339f07f!2sPacific%20Contract!5e0!3m2!1sen!2sin!4v1710157098873!5m2!1sen!2sin"
            title="PacifiContract location"
            className="h-[280px] w-full border-0 sm:h-[380px] md:h-[450px]"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
